// extracted by mini-css-extract-plugin
export default {"root":"_3r7ykke3","light":"_1tLNHSID","noBorder":"_2VB2Uwlo","title":"_1l4Wj1ud","rightButton":"_22Y3aDGp","icon":"_1rdkEYpQ","bottomContent":"_26m3xOVK"};